import React from 'react';
import InfoBox from 'components/widget/InfoBox';
import { CANT_CHANGE_ORDER_MESSAGE_PENDING } from 'helpers/copyHelper';

export default () => (
  <InfoBox>
    {CANT_CHANGE_ORDER_MESSAGE_PENDING()}
  </InfoBox>
);
